import { Route } from 'react-router-dom';

import { TaxDetailPage } from './pages/tax-detail-page.js';
import { TaxFormPage } from './pages/tax-form-page.js';
import { TaxListPage } from './pages/tax-list-page.js';

export function taxRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/taxes" element={<TaxListPage />} />
      <Route path="/taxes/new" element={<TaxFormPage />} />
      <Route path="/taxes/:taxId/edit" element={<TaxFormPage />} />
      <Route path="/taxes/:taxId" element={<TaxDetailPage />} />
    </>
  );
}
